import Component from './AlertCount.vue';

export default {
  install(Vue) {
    Vue.component('BkfAlertCount', Component);
  },
};
